import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SortArgs, SortDirection } from "../../../core/models/sort.model";

@Component({
    selector: 'column-header',
    templateUrl: './column-header.component.html',
    styleUrls: ['./column-header.component.scss'],
    standalone: false
})
export class ColumnHeaderComponent implements OnInit {

    @Input() allowSorting: boolean = true;
    @Input() property: string;
    sortDirections = SortDirection;

    @Output() sorting: EventEmitter<SortArgs> = new EventEmitter<SortArgs>();

    constructor() { }

    ngOnInit() {
    }

    sort(direction: SortDirection): void {
        const args = new SortArgs(direction, this.property);
        this.sorting.emit(args);
    }


}
